import { Modal } from './Modal';

export type SeriesScope = 'one' | 'future';

interface ScopeDialogProps {
  title: string;
  description: string;
  oneLabel: string;
  futureLabel: string;
  pending: boolean;
  onChoose: (scope: SeriesScope) => void;
  onCancel: () => void;
}

/** The "cette séance / toutes les séances à venir" choice on a series-born appointment. */
export function ScopeDialog({
  title,
  description,
  oneLabel,
  futureLabel,
  pending,
  onChoose,
  onCancel,
}: ScopeDialogProps) {
  return (
    <Modal title={title} onClose={onCancel}>
      <p className="modal__text">{description}</p>
      <div className="modal__choices">
        <button
          type="button"
          className="button button--primary"
          disabled={pending}
          onClick={() => onChoose('one')}
        >
          {oneLabel}
        </button>
        <button
          type="button"
          className="button"
          disabled={pending}
          onClick={() => onChoose('future')}
        >
          {futureLabel}
        </button>
      </div>
      <div className="modal__actions">
        <button type="button" className="button button--ghost" disabled={pending} onClick={onCancel}>
          Annuler
        </button>
      </div>
    </Modal>
  );
}
